// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import {
    GetOrderAwaitingApprovalApiParameter,
    getOrderAwaitingApprovals,
    OrderAwaitingApprovalCollectionModel,
} from "@guestsupply/App/Services/CustomerOrderAwaitingApprovalService";
import { ApiHandler, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetOrderAwaitingApprovalApiParameter, OrderAwaitingApprovalCollectionModel>;

export const DispatchBeginLoadingOrderAwaitingApproval: HandlerType = props => {
    props.dispatch({
        type: "Data/OrderApprovals/BeginLoadingOrderAwaitingApproval",
        parameter: props.parameter,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await getOrderAwaitingApprovals(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    }
};

export const DispatchCompleteLoadingOrderAwaitingApproval: HandlerType = props => {
    props.dispatch({
        type: "Data/OrderApprovals/CompleteLoadingOrderAwaitingApproval",
        collection: props.apiResult,
        parameter: props.parameter,
    } as any);
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadingOrderAwaitingApproval,
    RequestDataFromApi,
    DispatchCompleteLoadingOrderAwaitingApproval,
];

const loadCustomerOrderAwaitingApproval = createHandlerChainRunnerOptionalParameter(
    chain,
    {},
    "LoadCustomerOrderAwaitingApproval",
);
export default loadCustomerOrderAwaitingApproval;
